import { Form, VacationHome } from 'app/hooks/useGlobalForm';
import { SystemParameterInterface } from 'ks-common';
import { checkRestrictedAddress } from './addressMatcher';

interface CommonProps {
  vacationHomeForm:
    | Form['deliveryLocation']['vacationHome']
    | Form['returnLocation']['vacationHome'];
  isSubmit?: boolean;
  unservedResorts?: string;
}

interface AddressProps extends CommonProps {
  bannedList?: string[] | undefined;
}

interface ZipProps extends CommonProps {
  systemParams?: SystemParameterInterface[];
}

type CheckErrors = (
  props: AddressProps,
) => undefined | Partial<Record<keyof VacationHome, string>>;

const checkVacationHomeFieldsErrors: CheckErrors = props => {
  const { bannedList, isSubmit, vacationHomeForm } = props;

  const errors: Partial<Record<keyof VacationHome, string>> = {};

  if (bannedList && vacationHomeForm?.streetAddress) {
    const refIndex = checkRestrictedAddress(
      vacationHomeForm.streetAddress,
      bannedList,
    );

    if (refIndex !== null) {
      errors.streetAddress = `We are unable to deliver to ${vacationHomeForm.streetAddress}. Please select an alternative address.`;
    }
  }

  if (isSubmit) {
    if (
      !vacationHomeForm?.addressUnknown &&
      vacationHomeForm?.zip?.length !== 5
    ) {
      errors.zip = 'Please enter the ZIP code';
    }

    if (
      !vacationHomeForm?.addressUnknown &&
      vacationHomeForm?.zip?.length === 5
    ) {
      if (!vacationHomeForm?.streetAddress)
        errors.streetAddress = 'Please enter the Street Address';
      if (!vacationHomeForm?.city) errors.city = 'Please enter the City';
      if (!vacationHomeForm?.state) errors.state = 'Please enter the State';
    }
  }

  if (Object.keys(errors).length) {
    return errors;
  }

  return undefined;
};

const checkVacationHomeZipError = (props: ZipProps) => {
  const { vacationHomeForm, systemParams } = props;

  const zipCode = vacationHomeForm?.zip || '';
  const addressUnknown = vacationHomeForm?.addressUnknown;

  const allowedZipCodes = systemParams?.find(
    param => param.ParamName === 'Vacation_Home_Zips',
  )?.ParamValue;

  const zipCodeNotAllowed =
    zipCode.length === 5 && !allowedZipCodes?.includes(zipCode);

  if (!addressUnknown && zipCodeNotAllowed) {
    return 'It looks like your delivery location is not in an area that we service.';
  }
  return '';
};

export { checkVacationHomeFieldsErrors, checkVacationHomeZipError };
